import React, { useState, useEffect, createRef } from 'react';
import { MDBCol, MDBRow } from 'mdbreact';
import { post } from 'axios';
import PropTypes from 'prop-types';
import _ from 'lodash';
import immutable from 'immutable';

import { callbackSvgs, contentSvgs } from 'assets/icons';

import useFetch from 'hooks/useFetch';
import endpoints from 'services/endpoints';
import { isType } from 'utils/core';

import If from 'components/If';
import Toast from 'components/Informations/Toast';
import Overlay from 'components/Informations/Overlay';

import FilledButton from 'components/Buttons/FilledButton';
import UnfilledButton from 'components/Buttons/UnfilledButton';

import InformationCard from 'components/Cards/InformationCard';
import Page from 'components/PageStructure';

import Checkbox from 'components/FormGroup/Checkbox';
import ContentLoader from 'components/Informations/Loaders/ContentLoader';
import DateField from 'components/FormGroup/DateField';
import PageLoader from 'components/Informations/Loaders/PageLoader';
import SelectField from 'components/FormGroup/SelectField';

import history from 'utils/history';
import { formatDate, totallyHours, isSameMonth } from 'utils/moment';

import FloatButton from './InternalComponents/FloatButton';

import './dateFieldModifier.css';
import * as S from './styles';

const getStatus = (id, item) => {
  const obj = {};
  switch (id) {
    case 1:
      obj.text = 'Pendente';
      obj.status = 'pending';
      break;
    case 3:
      obj.text = 'Reprovado';
      obj.status = 'refused';
      break;
    case 2:
      obj.text = 'Aprovado';
      obj.status = 'approved';
      break;
    default:
      obj.text = 'Recusado';
      obj.status = 'not-pointed';
  }
  return obj[item];
};

const GenerateArray = (arr, callback) =>
  Array.from({ length: arr.length }, callback);

export default function ApproveAppointments({ user }) {
  const { id_funcionario: idFuncionario } = user;
  const { approveHours, postApproval } = endpoints;

  const [totalExtraHours, setTotalExtraHours] = useState('00:00');
  const [totalWorkedHours, setTotalWorkedHours] = useState('00:00');

  const [pageLoading, setPageLoading] = useState(true);
  const [contentLoading, setContentLoading] = useState(false);

  const [getObserver, setGetObserver] = useState(false);
  const [arrAppointments, setArrAppointments] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [isTableBlocked, setIsTableBlocked] = useState(false);

  const [month, setMonth] = useState(new Date());
  const [formatedMonth, setFormatedMonth] = useState(
    formatDate(new Date(), 'MM-YYYY').replace('-', ''),
  );
  const [status, setStatus] = useState();
  const [employee, setEmployee] = useState();
  const [project, setProject] = useState();

  const [allCheck, setAllCheck] = useState(false);
  const [arrCheckStates, setArrCheckStates] = useState([]);

  const [sendObj, setSendObj] = useState([]);

  const [toastType, setToastType] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [toastClose, setToastClose] = useState(2000);

  const [overlayType, setOverlayType] = useState('');
  const [overlayVisibility, setOverlayVisibility] = useState(false);
  const [toast, setToast] = useState(false);

  const [approveAppointmens] = useFetch(
    `${approveHours}/${idFuncionario}/${formatedMonth}`,
    getObserver,
  );

  const checkBoxRefs = GenerateArray(appointments, () => createRef());

  const [employeeOpt, setEmployeeOpt] = useState([
    {
      label: 'Selecione um funcionário',
      value: null,
      first: true,
      type: 'employee',
    },
  ]);
  const [projectOpt, setProjectOpt] = useState([
    {
      label: 'Selecione um projeto',
      value: null,
      first: true,
      type: 'project',
    },
  ]);

  useEffect(() => {
    (async () => {
      setContentLoading(true);
      const response = await approveAppointmens;
      const responseData = (await isType(response, 'string'))
        ? JSON.parse(response)
        : response;
      const resultData = immutable.List(responseData).toJS();
      const orderedData = _.orderBy(
        resultData,
        ['aprovacao', 'funcionario', 'dt_apontamento'],
        ['desc', 'asc', 'asc'],
      );
      const blockCondition = orderedData[0]?.aprovacao_bloqueada;

      setIsTableBlocked(!!blockCondition);
      setContentLoading(false);
      setArrAppointments(orderedData);
      setPageLoading(false);
    })();
  }, [approveAppointmens]);

  // OBSERVA AS ALTERAÇÕES PARA FILTRAR OS DADOS DA TABLE
  useEffect(() => {
    (async () => {
      setContentLoading(true);
      setFormatedMonth(formatDate(month, 'MM-YYYY').replace('-', ''));
      const monthSelected = new Date(month);
      setFormatedMonth(formatDate(month, 'MM-YYYY').replace('-', ''));
      const filter = appointment => {
        const res = appointment;
        const date = new Date(res.dt_apontamento);

        const testMonth = isSameMonth(monthSelected, date);
        const testEmployee = appointment.id_funcionario === employee;
        const testProject = appointment.id_projeto === project;
        const testStatus = appointment.id_aprovacao === status;
        const returnNull = appointment.id_apontamento === NaN;

        let test;

        switch (true) {
          case !!month && !!employee && !!project && !!status:
            test = testMonth && testEmployee && testProject && testStatus;
            break;
          case !!month && !!employee && !!project:
            test = testMonth && testEmployee && testProject;
            break;
          case !!month && !!employee && !!status:
            test = testMonth && testEmployee && testStatus;
            break;
          case !!month && !!project && !!status:
            test = testMonth && testProject && testStatus;
            break;
          case !!month && !!employee:
            test = testMonth && testEmployee;
            break;
          case !!month && !!project:
            test = testMonth && testProject;
            break;
          case !!month && !!status:
            test = testMonth && testStatus;
            break;
          default:
            test = returnNull;
            break;
        }
        return test;
      };

      const result = await arrAppointments.filter(filter);

      setTotalWorkedHours(totallyHours(_.sumBy(result, 'horas_apontadas')));
      setTotalExtraHours(totallyHours(_.sumBy(result, 'horas_extras')));
      setAppointments(result);
      setContentLoading(false);
    })();

    return () => {
      setAppointments([]);
    };
  }, [arrAppointments, month, status, employee, project]);

  // ALTERA AS OPÇÕES DOS SELECTES DE PROJETOS E FUNCIONÁRIOS
  useEffect(() => {
    (async () => {
      setContentLoading(true);
      const response = await arrAppointments;
      const monthSelected = new Date(month);
      const monthly = response.filter(item =>
        isSameMonth(new Date(item.dt_apontamento), monthSelected),
      );

      const resProject = await project;
      const resEmployee = await employee;
      const genrows = (groups, groupKey) =>
        _.toPairs(groups).map(([key, data]) => ({ [groupKey]: key, data }));

      const gengroups = (data, iteratee, key) => {
        const grouped = _.groupBy(data, iteratee);
        return genrows(grouped, key);
      };

      const grouparray = (data, array) => {
        let result = [{ data }];
        array.forEach((arr, i) => {
          const key = arr.key || `k${i + 1}`;
          const iteratee = arr.iteratee || arr;

          result = _.flatten(
            result.map(row =>
              gengroups(row.data, iteratee, key).map(group => ({
                ...row,
                [key]: group[key],
                data: group.data,
              })),
            ),
          );
        });

        return _.flatten(result);
      };

      const getIdname = id => {
        const group = _.groupBy(
          monthly.filter(item => item.id_projeto === parseInt(id)),
          'identificacao',
        );

        const keys = Object.keys(group);
        return keys[0];
      };

      const arrProjetos = grouparray(monthly, ['id_projeto', 'projeto']).map(
        opt => ({
          label: `${opt.k2} | ${getIdname(parseInt(opt.k1))}`,
          value: parseInt(opt.k1),
        }),
      );

      const arrEmployee = grouparray(monthly, [
        'id_funcionario',
        'funcionario',
      ]).map(opt => ({
        label: opt.k2,
        value: parseInt(opt.k1),
      }));

      const mountOpt = (obj, idProject, idEmployee) => {
        let label;

        switch (obj.type) {
          case 'employee':
            if (idEmployee) {
              label = 'Limpar filtro';
            } else {
              label = 'Selecione um funcionário';
            }
            break;
          case 'project':
            if (idProject) {
              label = 'Limpar filtro';
            } else {
              label = 'Selecione um projeto';
            }
            break;
          default:
            label = '';
            break;
        }
        return [{ ...obj, label }];
      };

      const callbackSetSelectOpts = options => prev => {
        const defaultValue = prev.filter(item => item.value === null);
        const obj = defaultValue[0];
        const newDefaultValue = mountOpt(obj, resProject, resEmployee);
        const result = [...newDefaultValue, ...options];
        return _.orderBy(result, ['first', 'label'], ['asc', 'asc']);
      };

      setEmployeeOpt(callbackSetSelectOpts(arrEmployee));
      setProjectOpt(callbackSetSelectOpts(arrProjetos));
      setContentLoading(false);
    })();
  }, [arrAppointments, month, employee, project]);

  // RESETA O ESTADO DOS CHECKBOXES TODA VEZ QUE O ARRAY DE APONTAMENTOS É ALTERADO OU FILTRADO
  useEffect(() => {
    (() =>
      setArrCheckStates(
        GenerateArray(appointments, () => ({ state: false })),
      ))();
    return () => {
      setArrCheckStates([]);
      setAllCheck(false);
      setSendObj([]);
    };
  }, [appointments]);

  const handleChangeMonth = e => setMonth(e);
  const handleChangeStatus = e => setStatus(e.value);
  const handleChangeEmployee = e => setEmployee(e.value);
  const handleChangeProject = e => setProject(e.value);

  const handleCheckEach = index => e => {
    e.persist();

    const { checked } = e.target;
    const val = e.target.value;
    const obj = JSON.parse(val);
    const { id_apontamento: idApontamento } = obj;
    setArrCheckStates(prev => {
      const previous = prev;

      previous[index].state = checked;

      return [...prev];
    });

    const callback = prev => {
      if (checked) {
        return [...prev, { id_apontamento: idApontamento }];
      }

      return prev.filter(item => item.id_apontamento !== obj.id_apontamento);
    };

    setSendObj(callback);
  };

  const handleCheckAll = e => {
    e.persist();
    const { checked } = e.target;
    const checkElmts = checkBoxRefs.map(el => el.current);

    const mapAll = appointments.map(appointment => ({
      id_apontamento: appointment.id_apontamento,
    }));

    const prevCheckedStates = checkElmts.filter(el => el.checked);

    const prevElValues =
      !!prevCheckedStates.length &&
      prevCheckedStates.map(el => JSON.parse(el.value));

    const prevValues =
      !!prevElValues &&
      prevElValues.map(val => ({ id_apontamento: val.id_apontamento }));

    const callback = prev => {
      if (checked) {
        return [...mapAll];
      }
      if (prevValues.length) {
        if (prevValues.length === prev.length) {
          setArrCheckStates(states => {
            const arrStates = states.map(() => ({ state: false }));
            return [...arrStates];
          });
          return [];
        }
      }
    };

    setArrCheckStates(states => {
      const arrStates = states.map(() => ({ state: checked }));
      return [...arrStates];
    });

    setSendObj(callback);
    setAllCheck(checked);
  };

  const renderToast = (type, message, closeTime) => {
    const condition = closeTime !== undefined ? closeTime : toastClose;

    setToast(true);
    setToastMessage(message);
    setToastType(type);
    setToastClose(condition);

    setTimeout(() => {
      setToast(false);
      setToastMessage('');
      setToastType('');
    }, condition);
  };

  const renderOverlay = type => {
    switch (type) {
      case 'approve':
        return (
          <Overlay
            isOpen={overlayVisibility}
            type="warning"
            text={[
              'Você está ',
              <span>aprovando os apontamentos</span>,
              ' de todos os funcionários selecionados. Deseja continuar com esta ação?',
            ]}
          >
            <UnfilledButton
              text="Não"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(prev => !prev);
              }}
            />
            <FilledButton
              text="Sim"
              buttonClass="warn"
              handleClick={() => {
                const send = sendObj.map(item => ({
                  ...item,
                  data: { id_aprovacao: 2 },
                }));
                post(`${postApproval}`, send)
                  .then(response => {
                    switch (response.status) {
                      case 200:
                        renderToast(
                          'success',
                          `${
                            send.length > 1
                              ? 'Apontamentos aprovados com sucesso'
                              : 'Apontamento aprovado com sucesso'
                          }`,
                          6000,
                        );
                        setGetObserver(prev => !prev);
                        setSendObj([]);
                        break;
                      default:
                        return false;
                    }
                  })
                  .then(setOverlayVisibility(prev => !prev))
                  .catch(() =>
                    renderToast(
                      'error',
                      `${
                        send.length > 1
                          ? 'Erro ao aprovar os apontamentos. Por favor tente novamente'
                          : 'Erro ao aprovar o apontamento. Por favor tente novamente'
                      }`,
                      6000,
                    ),
                  );
              }}
            />
          </Overlay>
        );
      case 'refuse':
        return (
          <Overlay
            isOpen={overlayVisibility}
            type="warning"
            text={[
              'Você está ',
              <span>recusando os apontamentos</span>,
              ' de todos os funcionários selecionados. Deseja continuar com esta ação?',
            ]}
          >
            <UnfilledButton
              text="Não"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(prev => !prev);
              }}
            />
            <FilledButton
              text="Sim"
              buttonClass="warn"
              handleClick={() => {
                const send = sendObj.map(item => ({
                  ...item,
                  data: { id_aprovacao: 3 },
                }));
                post(`${postApproval}`, send)
                  .then(response => {
                    switch (response.status) {
                      case 200:
                        renderToast(
                          'success',
                          `${
                            send.length > 1
                              ? 'Apontamentos recusados com sucesso'
                              : 'Apontamento recusado com sucesso'
                          }`,
                          6000,
                        );
                        setGetObserver(prev => !prev);
                        setSendObj([]);
                        break;
                      default:
                        return false;
                    }
                  })
                  .then(setOverlayVisibility(prev => !prev))
                  .catch(() =>
                    renderToast(
                      'error',
                      `${
                        send.length > 1
                          ? 'Erro ao recusar os apontamentos. Por favor tente novamente'
                          : 'Erro ao recusar o apontamento. Por favor tente novamente'
                      }`,
                      6000,
                    ),
                  );
              }}
            />
          </Overlay>
        );
      default:
        return false;
    }
  };

  const MenuItems = [
    {
      label: 'Aprovar selecionados',
      action: cb => () => {
        setOverlayType('approve');
        setOverlayVisibility(true);
        cb();
      },
    },

    {
      label: 'Recusar selecionados',
      action: cb => () => {
        setOverlayType('refuse');
        setOverlayVisibility(true);
        cb();
      },
    },
  ];

  const optStatus = [
    { label: status ? 'Limpar filtro' : 'Selecione um status', value: null },
    { value: 1, label: 'Pendente' },
    { value: 2, label: 'Aprovado' },
    { value: 3, label: 'Recusado' },
  ];

  return (
    <>
      {toast && (
        <Toast
          type={toastType}
          message={toastMessage}
          autoClose={toastClose}
          hideProgress
        />
      )}

      {pageLoading && <PageLoader />}

      <Page
        title="Aprove ou rejeite apontamentos da sua equipe"
        subtitle="Realize o controle de apontamentos daqueles que respondem diretamente à você."
      >
        <MDBRow>
          <MDBCol lg="12">
            <S.TopInfo>
              <S.Cards>
                <InformationCard
                  counter={totalWorkedHours}
                  description="Total de horas trabalhadas"
                />
                <InformationCard
                  counter={totalExtraHours}
                  description="Total de horas extras"
                />
              </S.Cards>
              <FilledButton
                handleClick={() =>
                  history.push('/auth/appointments/pendencies')
                }
                text="Apontamento Administrativo"
              />
            </S.TopInfo>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol xs="12" md="12">
            <S.LineFlex>
              <div className="d-flex flex-column flex-grow-0 h-100">
                <DateField
                  selectedValue={month}
                  handleChange={handleChangeMonth}
                  name="filterDate"
                  className="w-100 date-to-approve"
                  labelText="Selecione um mês"
                />
              </div>

              <div className="flex-grow-1 ml-3 mr-2 ml-xs-0 mr-xs-0">
                <SelectField
                  name="chooseStatus"
                  hasLabelMargin
                  labelText="Status do apontamento"
                  value={optStatus.find(opt =>
                    !status ? !opt.value : opt.value === status,
                  )}
                  className="w-100"
                  options={
                    !arrAppointments.length
                      ? optStatus.filter(opt => !opt.value)
                      : optStatus
                  }
                  handleChange={handleChangeStatus}
                  hasSecondaryStyle
                />
              </div>

              <div className="flex-grow-1 ml-2 mr-2 ml-xs-0 mr-xs-0">
                <SelectField
                  name="chooseProject"
                  labelText="Visualizar apontamentos em"
                  hasLabelMargin
                  value={projectOpt.find(item =>
                    !project ? !item.value : item.value === project,
                  )}
                  className="w-100"
                  options={projectOpt}
                  handleChange={handleChangeProject}
                  hasSecondaryStyle
                />
              </div>

              <div className="flex-grow-1 ml-2 mr-0 ml-xs-0 mr-xs-0">
                <SelectField
                  name="chooseEmployee"
                  labelText="Visualizar apontamentos de"
                  hasLabelMargin
                  value={employeeOpt.find(item =>
                    !employee ? !item.value : item.value === employee,
                  )}
                  className="w-100"
                  options={employeeOpt}
                  handleChange={handleChangeEmployee}
                  hasSecondaryStyle
                />
              </div>
            </S.LineFlex>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol xs="12" md="12">
            <S.Table>
              <div className="table-responsive">
                <If
                  condition={
                    !appointments.length && !isTableBlocked && !contentLoading
                  }
                >
                  <S.Callback>
                    {callbackSvgs('interrogationWoman')}
                    <S.CallbackText>
                      <p>
                        {status &&
                          !project &&
                          `Não há registros de semânticos com apontamentos ${optStatus
                            .find(opt => opt.value === status)
                            .label.toLowerCase()}s neste mês.`}
                      </p>
                      <p>
                        {project &&
                          'Não existem semânticos alocados neste projeto'}
                      </p>
                      <p>
                        {!status &&
                          !project &&
                          !employee &&
                          'Não foram encontrados resultados para o mês selecionado. Verifique as opções selecionadas acima'}
                      </p>
                    </S.CallbackText>
                  </S.Callback>
                </If>

                <If condition={contentLoading}>
                  <ContentLoader />
                </If>

                <If condition={isTableBlocked}>
                  <S.Callback>
                    {callbackSvgs('circularMan')}
                    <S.CallbackText>
                      <p>
                        O mês selecionado foi ENCERRADO e não pode mais sofrer
                        alterações
                      </p>
                    </S.CallbackText>
                  </S.Callback>
                </If>

                <If
                  condition={
                    appointments.length && !contentLoading && !isTableBlocked
                  }
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">
                          <Checkbox
                            filled
                            id="selectAll"
                            name="selectAll"
                            onChange={handleCheckAll}
                            checked={allCheck}
                          />
                        </th>
                        <th scope="col">Nome do funcionário</th>
                        <th scope="col">Data</th>
                        <th scope="col">Horas apontadas</th>
                        <th scope="col">Horas extras</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {appointments.map((appointment, i) => (
                        <tr key={appointment.id_apontamento}>
                          <td>
                            {!!arrCheckStates.length && (
                              <Checkbox
                                ref={checkBoxRefs[i]}
                                onChange={handleCheckEach(i)}
                                id={`check-${i}`}
                                name={`check-${i}`}
                                value={JSON.stringify(appointment)}
                                checked={arrCheckStates[i].state}
                              />
                            )}
                          </td>
                          <td>{appointment.funcionario}</td>
                          <td>{formatDate(appointment.dt_apontamento)}</td>
                          <td>{totallyHours(appointment.horas_apontadas)}</td>
                          <td>
                            {totallyHours(appointment.horas_extras)}
                            {appointment.horas_extras > 0 ? (
                              <S.ExtraHourInfos>
                                <S.ExtraHourInfosIcon>
                                  {contentSvgs('information')}
                                </S.ExtraHourInfosIcon>
                                <S.ExtraHourInfosContent>
                                  <p>
                                    <span>Categoria: </span>
                                    {appointment.categoria}
                                  </p>
                                  <p>
                                    <span>Subcategoria: </span>
                                    {appointment.subcategoria_hora_extra}
                                  </p>
                                </S.ExtraHourInfosContent>
                              </S.ExtraHourInfos>
                            ) : (
                              ''
                            )}
                          </td>
                          <td
                            className={`status-${getStatus(
                              appointment.id_aprovacao,
                              'status',
                            )}`}
                          >
                            <span>{appointment.aprovacao}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </If>
              </div>
            </S.Table>
          </MDBCol>
        </MDBRow>
        {!!sendObj.length && (
          <FloatButton disabled={!sendObj.length} menuItems={MenuItems} />
        )}

        {overlayVisibility && !!overlayType && renderOverlay(overlayType)}
      </Page>
    </>
  );
}

ApproveAppointments.defaultProps = {
  user: {},
};

ApproveAppointments.propTypes = {
  user: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
};
